import { GraduationCap, Award } from "lucide-react";
import { education, certifications } from "../../data/portfolio";
import { Reveal, SectionHead } from "./Reveal";

export default function Education() {
  return (
    <section id="education" data-testid="education-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-40 bg-blush w-96 h-96 bottom-0 -right-32 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Foundations" title={<>Education &<br />credentials.</>} testid="education-heading" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
          <div className="space-y-6">
            {education.map((ed, i) => (
              <Reveal key={ed.degree} delay={i * 0.12}>
                <div data-testid={`education-card-${i}`} className="glass glass-hover p-8 md:p-9 flex gap-6 items-start">
                  <div className="w-12 h-12 rounded-2xl bg-stone/50 border border-white/60 flex items-center justify-center shrink-0">
                    <GraduationCap className="w-5 h-5 text-ink/70" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight text-ink leading-snug">{ed.degree}</h3>
                    <p className="mt-2 text-sm font-medium text-fog">{ed.school} · {ed.place}</p>
                    <p className="mt-1 text-xs font-semibold tracking-[0.2em] uppercase text-ink/40">{ed.year}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <div>
            <Reveal delay={0.1}>
              <p className="eyebrow mb-6">Certifications</p>
            </Reveal>
            <div className="border-t border-stone/80">
              {certifications.map((c, i) => (
                <Reveal key={c.name} delay={0.12 + i * 0.08}>
                  <div data-testid={`certification-row-${i}`} className="flex items-center gap-5 border-b border-stone/80 py-5 group">
                    <Award className="w-4 h-4 text-ink/35 shrink-0 transition-colors duration-300 group-hover:text-ink" strokeWidth={1.5} />
                    <div className="flex-1 min-w-0">
                      <p className="text-[15px] font-medium text-ink truncate">{c.name}</p>
                      <p className="text-xs text-fog mt-0.5">{c.issuer}</p>
                    </div>
                    <span className="text-xs font-semibold tracking-[0.16em] uppercase text-ink/40 shrink-0">{c.year}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
